export default __webpack_public_path__ + "static/media/sessionnote.d21434d5.png";